
import { defineComponent, SetupContext, PropType } from "vue";
import NativeClient from "@/client/native-client";
import {
  RequestRecognitionCandidateItem,
  CandidateInfo,
  StatusCameraCheck
} from "@/types/pantry";
import PantryCameraCheckView from "./PantryCameraCheckView.vue";

export default defineComponent({
  name: "PantryCameraCheckSelectView",
  components: {
    PantryCameraCheckView
  },
  props: {
    selectPosition: {
      type: Number,
      default: 0,
      required: true
    },
    foodList: {
      type: Array as PropType<RequestRecognitionCandidateItem[]>,
      default: [],
      required: true
    },
    update: {
      type: Number,
      default: 0,
      require: true
    },
    isFoodTimerExec: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const getFoodList = () => {
      NativeClient.sendDebugLog(
        "PantryCameraCheckSelectView onClickFood foodList=" + JSON.stringify(props.foodList)
      );
      return props.foodList;
    };
    const onClickFood = (inferenceResultFoodId: number, data: CandidateInfo) => {
      NativeClient.sendDebugLog(
        "PantryCameraCheckSelectView onClickFood inferenceResultFoodId=" + inferenceResultFoodId + " data=" + JSON.stringify(data)
      );
      context.emit("click-food", inferenceResultFoodId, data);
    };

    const onClickInput = (inferenceResultFoodId: number, data: CandidateInfo) => {
      NativeClient.sendDebugLog(
        "PantryCameraCheckSelectView onClickInput inferenceResultFoodId=" + inferenceResultFoodId + " data=" + JSON.stringify(data)
      );
      context.emit("click-input", inferenceResultFoodId, data);
    };

    const onStatus = (status: StatusCameraCheck) => {
      context.emit("status", status);
    };

    const selectImage = (fileName: string) => {
      context.emit("select-image", fileName);
    };

    return {
      getFoodList,
      onClickFood,
      onClickInput,
      onStatus,
      selectImage
    };
  }
});
